/**
 * Read the device's current GPS position via the browser Geolocation API.
 * Resolves to null when unsupported, denied, or timed out (never rejects) — the
 * caller flags "no location captured" rather than blocking the upload.
 */
export function getDeviceLocation(timeoutMs = 12000): Promise<{ lat: number; lng: number } | null> {
  return new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      resolve(null)
      return
    }
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 0 },
    )
  })
}
